<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <LoadingSpinner :loading="loadingItem" :text="$lang.sending_data" />
        <b-form @submit.prevent="save" v-show="!loadingItem">
          <b-alert
            variant="info"
            show
            class="font-weight-bold text-justify lh_30"
          >
            <i class="fas fa-info-circle fa-lg mr-2" />
            <span v-text="alertMessage" />
          </b-alert>
          <b-form-group
            :label="$lang.profileLang.select_user"
            label-for="user_selected"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.profileLang.select_user"
              :rules="$v.user_selected.$params"
            />
            <selectAsync
              :options="user_options"
              v-model="$v.user_selected.$model"
              label="text"
              id="value"
              :asyncFind="getUsers"
              :loading="user_loading"
              :isValid="
                $v.user_selected.$dirty ? !$v.user_selected.$error : null
              "
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.user_selected.$error ? 'block' : 'none',
              }"
              id="user_selected_feedback"
            >
              {{
                $lang.error_required | replace($lang.profileLang.select_user)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            :label="$lang.profileLang.select_term"
            label-for="term_selected"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.profileLang.select_term"
              :rules="$v.term_selected.$params"
            />

            <selectFind
              :options="term_options"
              v-model="$v.term_selected.$model"
              label="caption"
              id="id"
              :loading="term_loading"
              :isValid="
                $v.term_selected.$dirty ? !$v.term_selected.$error : null
              "
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.term_selected.$error ? 'block' : 'none',
              }"
              id="term_selected_feedback"
            >
              {{
                $lang.error_required | replace($lang.profileLang.select_term)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.profileLang.description"
              :rules="$v.description.$params"
              for="description"
            />
            <b-form-textarea
              class="input-style-offres"
              id="description"
              v-model="$v.description.$model"
              type="text"
              autocomplete="off"
              :rows="4"
              :placeholder="$lang.profileLang.description"
              :state="$v.description.$dirty ? !$v.description.$error : null"
            >
            </b-form-textarea>

            <b-form-invalid-feedback
              :style="{
                display: $v.description.$error ? 'block' : 'none',
              }"
              id="description_feedback"
            >
              {{
                $lang.error_required | replace($lang.profileLang.description)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="submit"
              size="md"
              variant="success"
              v-if="isAdmin(parentPermissions)"
            >
              {{ $lang.submitButton }}
              <i class="fa fa-check"></i>
            </b-button>
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="$emit('closeModal')"
            >
              {{ $lang.cancelButton }}
              <i class="fa fa-ban"></i>
            </b-button>
          </div>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  components: {
    LoadingSpinner,
  },
  validations: {
    user_selected: {
      required,
    },
    term_selected: {
      required,
    },
    description: {},
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loadingItem: false,
      user_options: [],
      user_selected: null,
      user_loading: false,
      term_options: [],
      term_selected: null,
      term_loading: false,
      description: null,
      alertMessage: this.$lang.add_cooperator_parvandeh_alert,
    };
  },
  created() {
    this.getTerms();
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    async getUsers(query) {
      if (!query || query.length < 2) {
        return;
      }

      try {
        this.user_loading = true;
        this.user_options = [];
        const url =
          this.$config.api_url +
          this.$config.profile.user_combo.replace("{0}", query);
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.user_options = data.map((x) => {
          return {
            text: `${pathOr("", ["name"], x)} - ${pathOr(
              "",
              ["national_code"],
              x
            )}`,
            value: pathOr("", ["code"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.user_loading = false;
      }
    },
    async getTerms() {
      try {
        this.term_loading = true;
        const url = generateApiUrl(["profile", "term_combo"]);
        const response = await this.$httpService.get(url);
        this.term_options = pathOr([], ["data", "data"], response).map(
          (item) => {
            return {
              caption: `${pathOr("", ["id"], item)} - ${pathOr(
                "",
                ["caption"],
                item
              )}`,
              id: pathOr(null, ["id"], item),
            };
          }
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.term_loading = false;
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loadingItem = true;
        const payload = {
          user_code: pathOr(null, ["value"], this.user_selected),
          term_id: pathOr(null, ["id"], this.term_selected),
          comment: this.description,
        };
        const url = generateApiUrl(["profile", "parvandeh"]);
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("closeModal");
        this.$emit("getData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingItem = false;
      }
    },
  },
};
</script>

